import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=2a1f37ac&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"
import style0 from "./Header.vue?vue&type=style&index=0&id=2a1f37ac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1f37ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a1f37ac')) {
      api.createRecord('2a1f37ac', component.options)
    } else {
      api.reload('2a1f37ac', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=2a1f37ac&scoped=true", function () {
      api.rerender('2a1f37ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/v2/page/Header.vue"
export default component.exports